export default {
  'mainTerms': {
    'rus': 'рус',
    'eng': 'eng'
  },
  'pages': {
    'select': {
      'title': 'Employees',
      'theyAreWorking': 'Working staff',
      'currentTime': 'Current time',
      'searchInput': 'Enter first or last name',
      'findButton': 'Find',
      'workTime': 'Working hours',
      'from': 'from',
      'till': 'to',
      'department': 'department',
      'company': 'company',
      'ticks': 'ticks',
      'tabelCode': 'Tabel code',
      'position': 'Position',
      'selectEmployee': 'Select employee',
      'coming': 'Coming',
      'leaving': 'Leaving',
      'noTabelcode': 'No tabel code',
      'noPosition': 'No position'
    },
    'fix': {
      'title': 'Employee tick',
      'worker': 'Employee',
      'shortInstruction': 'Position your face in the center of the circle',
      'shootButtonTitle': 'Take a photo',
      'reshootButtonTitle': 'Reshoot',
      'sendButtonTitle': 'Send',
      'coming': 'coming',
      'leaving': 'leaving',
      noFirstPicsError: 'Error saving the image from the camera. Try again.'
    },
    'results': {
      'title': 'Tick result',
      'comingOnSchedule': 'Today You have come in time!',
      'comingLate': 'Sorry, You are late!',
      'nonMarked': 'Marked out of plan!',
      'leavingOnSchedule': 'You left on time. Thanks for the work!',
      'leavingDumped': 'You left out of time',
      'tickSuccess': 'The tick was successful,',
      'tickFailure': 'Sorry, your face is not recognized',
      'tickOffline': 'Your photo will be processed later, because there is currently no Internet connection',
      'understood': 'All clear',
      'tryAgain': 'Try again',
      'todayPlan': 'Work plan for today',
      'planElementWaiting': 'Awaiting completion'
    }
  },
  'mainLayout': {
    'shopTitle': 'shop',
    'errorModalTitle': 'Error!'
  },
  'api': {
    502: 'Service is temporarily unavailable. Please try again later.'
  }
}
